<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="Part-Headers" id="_idParaDest-4"><span class="CharOverride-8"><a id="_idTextAnchor004"></a>Part One</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// AlongTheWay_ebook-5.vue?57be5cd1